module.exports = __webpack_public_path__ + "img/7bc78948-ef80-4ac2-a851-69e84153c8f5.8517e7e2.png";